import { InputTypes } from "constants/enums";
import { IFormField } from "models/app";
import React from "react";
import Modal from "components/UI/DialogModal";
import Form from "components/UI/Form";
import { CircularProgress, Grid } from "@mui/material";
import MuiButton from "components/UI/MuiButton";
import { ICompany } from "models/company";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  loading: boolean;
  company: ICompany;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}

const EditColors: React.FC<Props> = ({
  open,
  loading,
  company,
  onClose,
  onSubmit,
  onChanges,
}) => {
  const { t } = useTranslation();

  let basicFields: IFormField[] = [
    {
      name: "addUpdateIconColor",
      label: t('T_colors_1'),
      type: InputTypes.COLOR,
      internalLabel: false,
      defaultValue: company?.addUpdateIconColor,
    },
    {
      name: "addUpdateIconHoverColor",
      label: t('T_colors_2'),
      type: InputTypes.COLOR,
      internalLabel: false,
      defaultValue: company?.addUpdateIconHoverColor,
    },
    {
      name: "cancelButtonColor",
      label: t('T_colors_3'),
      type: InputTypes.COLOR,
      internalLabel: false,
      defaultValue: company?.cancelButtonColor,
    },
    {
      name: "cancelButtonHoverColor",
      label: t('T_colors_4'),
      type: InputTypes.COLOR,
      internalLabel: false,
      defaultValue: company?.cancelButtonHoverColor,
    },
    {
      name: "chartMainColor",
      label: t('T_colors_5'),
      type: InputTypes.COLOR,
      internalLabel: false,
      defaultValue: company?.chartMainColor,
    },
    {
      name: "deleteIconColor",
      label: t('T_colors_6'),
      type: InputTypes.COLOR,
      internalLabel: false,
      defaultValue: company?.deleteIconColor,
    },
    {
      name: "deleteIconHoverColor",
      label: t('T_colors_7'),
      type: InputTypes.COLOR,
      internalLabel: false,
      defaultValue: company?.deleteIconHoverColor,
    },
    {
      name: "labelColor",
      label: t('T_colors_8'),
      type: InputTypes.COLOR,
      internalLabel: false,
      defaultValue: company?.labelColor,
    },
    {
      name: "menuBgColor",
      label: t('T_colors_9'),
      type: InputTypes.COLOR,
      internalLabel: false,
      defaultValue: company?.menuBgColor,
    },
    {
      name: "menuItemHoverColor",
      label: t('T_colors_10'),
      type: InputTypes.COLOR,
      internalLabel: false,
      defaultValue: company?.menuItemHoverColor,
    },
    {
      name: "menuItemSelectedColor",
      label: t('T_colors_11'),
      type: InputTypes.COLOR,
      internalLabel: false,
      isHorizontal: true,
      defaultValue: company?.menuItemSelectedColor,
    },
    {
      name: "viewIconColor",
      label: t('T_colors_12'),
      type: InputTypes.COLOR,
      internalLabel: false,
      defaultValue: company?.viewIconColor,
    },
    {
      name: "viewIconHoverColor",
      label: t('T_colors_13'),
      type: InputTypes.COLOR,
      internalLabel: false,
      defaultValue: company?.viewIconHoverColor,
    },
  ];

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title="Edit Colors"
        maxWidth="xl"
        children={
          <Grid container p={2}>
            <Form fields={basicFields} onChange={onChanges} />
          </Grid>
        }
        actions={
          <Grid
            container
            alignItems={"center"}
            justifyContent={"space-between"}
            px={1}
          >
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "warning.main", color: "white" }}
              size="large"
              onClick={onClose}
            >
               {t('T_cancel')}
            </MuiButton>
            <MuiButton
              variant="contained"
              sx={{ bgcolor: "primary.main", color: "white" }}
              disabled={loading}
              size="large"
              onClick={onSubmit}
            >
                {t('T_save')}
              <CircularProgress
                size={10}
                sx={{ mx: 2, display: loading ? "" : "none" }}
              />
            </MuiButton>
          </Grid>
        }
      />
    </>
  );
};

export default EditColors;
